module.exports = __webpack_public_path__ + "public/img/cc.130c994d.png";